import React, { useState } from 'react';
import DemoErrorBoundary from './DemoErrorBoundary';

function CopyButton({ text, label }) {
  const [copied, setCopied] = useState(false);
  const copy = () => {
    navigator.clipboard.writeText(text).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 1500);
    });
  };
  return (
    <button
      type='button'
      className='btn ghost sm'
      onClick={copy}
    >
      <i className={copied ? 'fa-solid fa-check' : 'fa-regular fa-copy'} /> {label}
    </button>
  );
}

export default function DemoEntryView({ demo }) {
  const Render = demo.render;
  return (
    <article className='dsg-entry-view'>
      <h2 className='dsg-title'>{demo.title}</h2>
      {demo.importPath ? (
        <div className='dsg-import'>
          <code>{demo.importPath}</code>
          <CopyButton
            text={demo.importPath}
            label='Copy path'
          />
        </div>
      ) : null}
      {demo.notes && demo.notes.length > 0 ? (
        <ul className='dsg-notes'>
          {demo.notes.map((note, i) => (
            <li key={i}>{note}</li>
          ))}
        </ul>
      ) : null}
      <div className='dsg-canvas'>
        <DemoErrorBoundary>
          <Render />
        </DemoErrorBoundary>
      </div>
      {demo.snippet ? (
        <div className='dsg-snippet'>
          <div className='dsg-snippet-head'>
            <span>Usage</span>
            <CopyButton
              text={demo.snippet}
              label='Copy snippet'
            />
          </div>
          <pre>
            <code>{demo.snippet}</code>
          </pre>
        </div>
      ) : null}
    </article>
  );
}
